import { render, staticRenderFns } from "./nfcreader_bind.vue?vue&type=template&id=9ea15676&"
import script from "./nfcreader_bind.vue?vue&type=script&lang=js&"
export * from "./nfcreader_bind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports